<template>
  <div class="custom-select-box" :tabindex="tabindex" @blur="open = false">
    <div class="selected" :class="{ open: open, error: error }" @click="open = !open">
      <span v-if="!selected">Select step</span>
      <span v-else-if="selected.type !== 'SurveyCompletion'"
        >Step {{ selected.stepSequence }}
        <b-badge v-if="selected.isSkippable" variant="secondary">Optional</b-badge>
      </span>
      <span v-else-if="selected.subtype === 'custom'">Custom Completion</span>
      <span v-else>End Activity</span>
    </div>
    <div class="items" :class="{ selectHide: !open, bottom: alignBottom, top: !alignBottom }">
      <div
        class="item"
        v-for="option of options"
        :key="`skip-to-${option.id}`"
        @click="
          selected = option;
          open = false;
          $emit('input', option);
        "
      >
        <div class="type">
          <span v-if="option.type !== 'SurveyCompletion'"
            >Step {{ option.stepSequence }} -
            {{ questionTypes[option.type] }}
            <b-badge v-if="option.isSkippable" variant="secondary">Optional</b-badge>
          </span>
          <span v-else-if="option.subtype === 'custom'">Custom Completion</span>
          <span v-else>End Activity</span>
        </div>
        <div class="title" :title="option.body">
          <span v-if="option.type == 'SurveyCompletion'">Skips to the end of the activity</span>
          <span v-else>{{ option.body }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
export default {
  name: "SkipToDropDown",
  props: {
    options: {
      type: Array,
      required: true
    },
    tabindex: {
      type: Number,
      required: false,
      default: 0
    },
    selectedOptionId: {
      type: String
    },
    questionTypes: {
      type: Object,
      required: true
    },
    error: {
      type: Boolean,
      default: false
    },
    alignBottom: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    selectedOptionId: {
      handler(selectedStepId) {
        if (!selectedStepId) {
          this.selected = null;
          return;
        }
        if (this.selected && selectedStepId == this.selected.id) {
          return;
        }

        this.selected = _.find(this.options, {
          id: selectedStepId
        });
      },
      deep: true
    },
    options: {
      handler(qoptions) {
        //Code handles recursive loop end selected question
        if (!this.selectedOptionId) {
          return;
        }
        const qF = _.find(qoptions, {
          id: this.selectedOptionId
        });
        if (qF) {
          this.selected = qF;
        } else {
          this.selected = null;
        }
      },
      deep: true
    }
  },
  data() {
    return {
      selected: _.find(this.options, {
        id: this.selectedOptionId
      }),
      open: false
    };
  },
  mounted() {
    this.$emit("input", this.selected);
  }
};
</script>

<style lang="scss" scoped>
.custom-select-box {
  position: relative;
  width: 100%;
  text-align: left;
  outline: none;
  font-size: 12px;
  font-weight: normal;

  .selected {
    background-color: #ffffff;
    border-radius: 4px;
    border: solid 1px #d3dfe4;
    color: #4a4a4a;
    padding: 7px;
    padding-left: 11px;
    cursor: pointer;
    user-select: none;
    text-transform: capitalize;

    &:after {
      position: absolute;
      content: "";
      top: 13px;
      right: 10px;
      width: 0;
      height: 0;
      border: 6px solid transparent;
      border-color: #b0bac9 transparent transparent transparent;
    }

    .badge {
      padding: 4px;
      border-radius: 2px;
      background-color: #eee;
      font-family: Roboto-Regular;
      font-size: 9px;
      margin-left: 8px;
      color: #4a4a4a;
    }

    &.error {
      border-color: #f16559;
    }
  }

  .items {
    color: #4a4a4a;
    border-radius: 4px;
    overflow: hidden;
    position: absolute;
    background-color: #ffffff;
    left: 11px;
    right: 1px;
    box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.25);
    z-index: 1;
    min-width: 316px;
    max-height: 223px;
    overflow-y: auto;
    padding: 16px;

    &.bottom {
      bottom: 9px;
    }

    &.top {
      top: 9px;
    }

    scrollbar-width: thin;
    /* "auto" or "thin"  */
    scrollbar-color: #e6e9ed transparent;

    /* scroll thumb & track */
    &::-webkit-scrollbar {
      width: 7px;
      /* width of the entire scrollbar */
    }

    &::-webkit-scrollbar-track {
      background: transparent;
      /* color of the tracking area */
    }

    &::-webkit-scrollbar-thumb {
      background-color: #c5d1d6;
      /* color of the scroll thumb */
      border-radius: 20px;
      /* roundness of the scroll thumb */
      border: 3px solid transparent;
      /* creates padding around scroll thumb */
    }

    .item {
      color: #666669;
      cursor: pointer;
      user-select: none;
      margin-bottom: 4px;

      &:hover {
        background-color: #f8f9fa;
      }

      &:last-of-type {
        margin-bottom: 0;
      }

      .type {
        font-family: Roboto-Bold;
        font-size: 14px;
        color: #4a4a4a;
        text-transform: capitalize;
        margin-bottom: -2px;

        .badge {
          padding: 4px;
          border-radius: 2px;
          background-color: #eee;
          font-family: Roboto-Medium;
          font-size: 9px;
          margin-left: 8px;
          color: #4a4a4a;
        }
      }

      .title {
        font-size: 12px;
        color: #666669;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
}

.selectHide {
  display: none;
}
</style>
